@use '@lib/assets/styles/main.scss' as *;

.documentsList {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
}

.documentItem {
  display: flex;
  align-items: center;
  gap: 8px;
}

.documentPreview {
  flex: 1;
  min-width: 0;
}

.requiredToReadSelect {
  width: 84px;
  flex-shrink: 0;
}
